var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TeamInvitation',{attrs:{"title":_vm.title},on:{"send-invites":_vm.sendInvites}})
}
var staticRenderFns = []

export { render, staticRenderFns }